<template>
  <Page current-link="books/paperback">
    <BookWatermark/>
    <div class="col-center">
      <div class="title col">
        <img src="/books/title.png"/>
      </div>
      <div class="desktop row-center-reactive book-info-page">
        <div class="book-info-wrapper">
          <img src="/books/paperback.jpg" class="book-info-img"/>
          <PaperbackInfo/>
        </div>
        <div class="book-margin"></div>
        <Blurb :book="books.paperbackBook"></Blurb>
      </div>
      <div class="mobile col-center-nopad book-info-page">
        <img src="/books/paperback.jpg" class="book-info-img"/>
        <div class="book-margin"></div>
        <Blurb :book="books.paperbackBook"></Blurb>
        <div class="book-margin"></div>
        <div class="book-info-wrapper">
          <PaperbackInfo/>
        </div>
      </div>
    </div>
  </Page>
</template>

<script setup lang="ts">
import {useBooksStore} from "~/store/books";
import BookWatermark from "~/pages/books/BookWatermark.vue";
import PaperbackInfo from "~/pages/books/PaperbackInfo.vue";

const books = useBooksStore();
books.fetchBooks();
</script>
